<template lang="pug">
    div(class="text-sm text-gray leading-4" data-testid="filteredFitment")
        span {{ fitmentFormatted }}
        span(v-if="fitmentFormattedSecondary") , {{ fitmentFormattedSecondary }}
</template>

<script>
export default {
    computed: {
        fitmentFormatted() {
            return this.$store.getters['fitment/fitmentFormatted']
        },
        fitmentFormattedSecondary() {
            return this.$store.getters['fitment/fitmentFormattedSecondary']
        },
    },
}
</script>
